import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import { NotFound } from '../../app/routing/NotFound';

const SamAccount = lazy(() => import('./SamAccount'));

export default function AdminSamAccountRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SamAccount />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
